import type { ComponentProps } from "react";

export function ChevronDownIcon(props: ComponentProps<"svg">) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M15.4798 10C15.6895 10 15.806 10.2425 15.6751 10.4062L12.1952 14.756C12.0951 14.8811 11.9049 14.8811 11.8048 14.756L8.32494 10.4062C8.19399 10.2425 8.31053 10 8.52016 10L15.4798 10Z"
        fill="currentColor"
      />
    </svg>
  );
}
